/* RESPONSIBLE TEAM: team-fin-voice */
import type FinVoice from 'embercom/models/operator/visual-builder/step/fin-voice';
import StepConfig, { type StepConfigParams } from '../step';
// eslint-disable-next-line no-restricted-imports
import containerLookup from 'embercom/lib/container-lookup';

export default class FinVoiceStepConfig extends StepConfig {
  declare step: FinVoice;
  appService: any;
  triggerDeleteFinVoiceModalCallback?: () => void;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/fin-voice',
      ...params,
    });

    this.appService = containerLookup('service:appService');
  }

  get stepMenuConfigOptions() {
    return [
      {
        icon: 'trash',
        text: this.intl.t('operator.workflows.visual-builder.delete'),
        isDisabled: !this.canDeleteStep,
        tooltipText: this.deleteTooltipText,
        dataTest: 'fin-voice-step-menu-delete',
        onSelectItem: () => {
          this.triggerDeleteFinVoiceModalCallback?.();
        },
      },
    ];
  }
}
